var map = {
	"./music-instructions.json": 4578,
	"./music-library-intro2024.json": 4579,
	"./music-library-launch2024.json": 4580,
	"./music-progression.json": 4581,
	"./startSourcesAdvanced.json": 4582,
	"./startSourcesSimple.json": 4583,
	"./startSourcesSimple2.json": 4584,
	"./startSourcesTracks.json": 4585
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4348;